import { get } from "lodash";
import format from "string-template";
import * as yup from "yup";

const validation = (messages, includedChildren = []) => {
  const schemaShape = {};
  includedChildren.forEach(({ userId, identity }) => {
    schemaShape[`socialSecurityCertificate_${userId}`] = yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(
        format(
          messages.REQUIRED_CHILD_ATTACHMENT || messages.REQUIRED_ATTACHMENT,
          {
            firstName: get(identity, "user.firstname", ""),
            lastName: get(identity, "user.lastname", ""),
          },
        ),
      )
      .min(
        1,
        format(
          messages.REQUIRED_CHILD_ATTACHMENT || messages.REQUIRED_ATTACHMENT,
          {
            firstName: get(identity, "user.firstname", ""),
            lastName: get(identity, "user.lastname", ""),
          },
        ),
      );
  });

  return yup.object().shape(schemaShape);
};

export default validation;
